// see http://vuejs-templates.github.io/webpack for documentation.
var path = require('path')
var env = require('../env')

module.exports = {
  build: {
    env: require('./prod.env'),
    index: path.resolve(__dirname, '../../public_build/vue.php'),
    assetsRoot: path.resolve(__dirname, '../../public_build/'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    productionSourceMap: true,
    baseURL: env.baseURL, //referred to backend domain (ex. laravel)
    sessionTimeout: env.sessionTimeout,
    apiVersion: env.apiVersion,
    defaultBaseURL: env.defaultBaseURL,
    mocker: env.mocker,
    mockerLogin: env.mockerLogin,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css']
  },
  dev: {
    env: require('./dev.env'),
    port: 8080,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}



// WEBPACK FOOTER //
// ./config/index.js